export default () => ({
    ticking: false,
    offScreen: false,
    activeIndex: 0,
    textElements: [],
    imageElements: [],
    footer: document.getElementById('footer'),
    isMobile: window.innerWidth < 1024,

    init() {
        this.textElements = Array.from(this.$root.querySelectorAll('[data-split-scroll-text]'))
        this.imageElements = Array.from(this.$root.querySelectorAll('[data-split-scroll-image]'))

        
        if (this.footer && this.textElements && this.imageElements && !this.isMobile) {
            this.updateActiveIndex()
            document.addEventListener('scroll', this.handleScroll.bind(this))

            window.addEventListener('resize', () => this.isMobile = window.innerWidth < 1024)
        }
    },

    handleScroll() {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.updateActiveIndex()
                this.ticking = false
            })

            this.ticking = true
        }
    },
    updateActiveIndex() {
        const updatedIndex = this.imageElements.findIndex(e => this.elementIsVisible(e))
        this.activeIndex = updatedIndex !== -1 ? updatedIndex : this.activeIndex
        this.checkContainerIsOnScreen()
    },
    elementIsVisible(element) {
        const rect = element.getBoundingClientRect()
        return rect.top < (element.offsetHeight / 2) && rect.top > ((element.offsetHeight / 2) * -1)
    },
    checkContainerIsOnScreen() {
        if (this.activeIndex === this.imageElements.length - 1) {
            const rootRect = this.$root.getBoundingClientRect()

            this.offScreen = (rootRect.bottom - this.footer.offsetHeight) <= 0
        }
    }
})
